import React from 'react';
import { Link, useNavigate, Outlet, useLocation } from 'react-router-dom';

function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="admin-dashboard">
      <aside className="admin-sidebar">
        <h2>Yamas CMS</h2>
        <ul className="admin-menu">
          <li><Link to="/admin/dashboard" className={isActive('/admin/dashboard')}>Dashboard</Link></li>
          <li><Link to="/admin/users" className={isActive('/admin/users')}>Users</Link></li>
          <li><Link to="/admin/pages" className={isActive('/admin/pages')}>Pages</Link></li>
          <li><Link to="/admin/menu" className={isActive('/admin/menu')}>Menu</Link></li>
          <li><Link to="/admin/gallery" className={isActive('/admin/gallery')}>Gallery</Link></li>
          <li><Link to="/admin/testimonials" className={isActive('/admin/testimonials')}>Testimonials</Link></li>
          <li><Link to="/admin/settings" className={isActive('/admin/settings')}>Settings</Link></li>
        </ul>
      </aside>
      
      <main className="admin-content">
        <div className="admin-header">
          <h1>Admin Panel</h1>
          <div>
            <span style={{marginRight: '20px'}}>Welcome, {user.username}</span>
            <button onClick={handleLogout} className="btn-logout">Logout</button>
          </div>
        </div>
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
